<div class="p-6 flex h-full w-full justify-center items-center">
  <div class="rounded-lg bg-gradient-to-b from-purple-200 to-blue-200 p-16">
    <div class="w-auto max-w-[650px] flex items-center flex-col gap-6 min-w-96 border rounded-md border-gray-medium shadow-sm bg-white p-16">
      <div class="font-bold text-9xl text-center w-96">
        <span class="text-theme-primary">E</span>
        <span class="text-teal-500">C</span>
        <span class="text-yellow-500">3</span>
      </div>
      <div class="flex flex-col gap-4 items-center">
        <div class="text-gray-700 text-center">{{ 'common.auth.welcome.title' | translate }}</div>
        <div class="text-sm text-slate-400 text-center">{{ 'common.auth.welcome.description' | translate }}</div>
      </div>
    </div>
  </div>
</div>
